import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { ROUTES } from '@/lib/constants';
import { LoadingScreen } from '@/components/ui/LoadingScreen';
import { toast } from 'sonner';

export const AdminRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  useEffect(() => {
    if (!loading && isAuthenticated && !isAdmin) {
      toast.error('No tienes permisos para acceder al panel de administración.');
    }
  }, [loading, isAuthenticated, isAdmin]);

  if (loading) return <LoadingScreen />;
  if (!isAuthenticated) return <Navigate to={ROUTES.login} replace />;
  if (!isAdmin) return <Navigate to={ROUTES.dashboard} replace />;
  return children;
};
